import { createTeamResourceContext } from './createTeamResourceContext'
import useDomainsResources from '../shared/resources/api/v1/admin/networking/useDomainsResources'

const { Provider: DomainsProvider, useHook: useDomains, useSafeHook: useDomainsSafe } = createTeamResourceContext({
  name: 'Domains',
  useResources: useDomainsResources,
  responseKey: 'domains',
  lookups: [{ key: 'domainsById', field: 'id' }],
})

export { DomainsProvider, useDomains, useDomainsSafe }
